/* eslint-disable no-console */
class Zaraz {
  static isScriptLoaded = false;
  static queue = [];

  static enqueue(method, args) {
    if (this.isScriptLoaded) {
      window.zaraz[method](...args);
    } else {
      if (window.RAILS_ENV === 'development') {
        console.log(`Zaraz (Dev): ${method}`, args);
      }

      this.queue.push([method, args]);
    }
  }

  static ecommerce(event, payload) {
    this.enqueue('ecommerce', [event, payload]);
  }

  static track(event, payload) {
    this.enqueue('track', [event, payload]);
  }

  static set(prop, value, params = {}) {
    this.enqueue('set', [prop, value, params]);
  }

  static setContentGroup() {
    window.zaraz.set('content_group', gon.current_path, { scope: 'page' });
  }

  static start() {
    const intervalId = setInterval(() => {
      if (!window.zaraz) {
        return;
      }

      Zaraz.isScriptLoaded = true;
      clearInterval(intervalId);

      this.setContentGroup();
      document.addEventListener('turbolinks:load', () => {
        this.setContentGroup();
      });

      this.queue.forEach(([method, args]) => {
        window.zaraz[method](...args);
      });
    }, 1000);
  }
}

if (window.RAILS_ENV !== 'development') {
  Zaraz.start();
}

export default Zaraz;
